import { useEffect } from 'react';
import { useAuth } from '../state/AuthContext';

export default function useSubscriptionAccess() {
  const { isSubscriptionActive } = useAuth();
  // const isSubscriptionActive = false; //÷÷ hardcoded for testing — swap to useAuth() line above when done
  
  useEffect(() => {
    if (isSubscriptionActive === null) {
      console.log('[Subscription] Loading — status not yet determined');
    } else if (isSubscriptionActive === true) {
      console.log('[Subscription] User HAS an active subscription');
    } else {
      console.log('[Subscription] User does NOT have a subscription (table locked)');
    }
  }, [isSubscriptionActive]);

  return {
    isLocked: isSubscriptionActive === false,
    isLoading: isSubscriptionActive === null,
  };
}
